import React from "react";
import "./FlightSearchDown.css";

const FlightOffers = () => {
  return (
    <div className="fl-wrapper">

      {/* OFFERS */}
      {/* <section className="fl-section">
        <h2 className="fl-heading">🔥 Exclusive Flight Offers</h2>

        <div className="fl-offer-grid">
          <div className="fl-offer-card">
            <span className="fl-badge">LIMITED</span>
            <h3>Flat ₹1200 OFF</h3>
            <p>On domestic flight bookings</p>
            <div className="fl-coupon">FLY1200</div>
          </div>

          <div className="fl-offer-card">
            <span className="fl-badge">NEW USER</span>
            <h3>Up to ₹1500 OFF</h3>
            <p>First-time flight booking</p>
            <div className="fl-coupon">NEWFLY</div>
          </div>

          <div className="fl-offer-card">
            <span className="fl-badge">BANK</span>
            <h3>10% Instant Discount</h3>
            <p>Using selected credit cards</p>
            <div className="fl-coupon">BANK10</div>
          </div>
        </div>
      </section> */}

      {/* RULES */}
      <section className="fl-section fl-light-bg">
        <h2 className="fl-heading">📜 Rules & Regulations</h2>

        <ul className="fl-rules">
          <li>Coupons are applicable on base fare only.</li>
          <li>Only one coupon can be used per booking.</li>
          <li>Offers are subject to airline availability.</li>
          <li>Flight reschedule charges may apply.</li>
          <li>Discount amount varies based on route & date.</li>
        </ul>
      </section>

      {/* TESTIMONIALS */}
      <section className="fl-section">
        <h2 className="fl-heading">💬 What Our Travelers Say</h2>

        <div className="fl-testimonial-grid">
          <div className="fl-testimonial-card">
            <p>
              “Super smooth booking experience! Got instant discounts and great
              flight options.”
            </p>
            <h4>— Rahul Sharma</h4>
          </div>

          <div className="fl-testimonial-card">
            <p>
              “Loved the UI and fast booking. The coupon worked perfectly!”
            </p>
            <h4>— Ananya Verma</h4>
          </div>

          <div className="fl-testimonial-card">
            <p>
              “Best flight booking platform. Clear rules and amazing offers.”
            </p>
            <h4>— Aman Khan</h4>
          </div>
        </div>
      </section>

    </div>
  );
};

export default FlightOffers;
